export default function getWindowViewportRect() {
	return {
		top: window.scrollY,
		left: window.scrollX,
		width: window.innerWidth,
		height: window.innerHeight
	};
}
